// ---------------------------------------------- modules import
import {
  IPinnedPostState,
  PinnedPostAction,
  PinnedPostActionType
} from "./common";

const initialState: IPinnedPostState = {
  loading: false,
  error: null
};

// ---------------------------------------------- the reducer
const pinnedPostReducer = (
  state = initialState,
  action: PinnedPostAction
): IPinnedPostState => {
  switch (action.type) {
    case PinnedPostActionType.UPDATE_PINNEDPOST_BEGIN:
    case PinnedPostActionType.UNPIN_PINNEDPOST_BEGIN: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case PinnedPostActionType.UPDATE_PINNEDPOST_SUCCESS:
    case PinnedPostActionType.UNPIN_PINNEDPOST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      };
    }
    case PinnedPostActionType.UPDATE_PINNEDPOST_ERROR:
    case PinnedPostActionType.UNPIN_PINNEDPOST_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload.error
      };
    }
    default: {
      return state;
    }
  }
};

export default pinnedPostReducer;
